import { z } from "zod"

export const EditEventCalendarFormSchema = z
  .object({
    startDate: z.string().datetime(),
    endDate: z.string().datetime(),
    timezone: z.string().min(1).max(50),
  })
  .refine((data) => new Date(data.endDate) > new Date(data.startDate), {
    message: "End date must be after start date",
    path: ["endDate"],
  })

export type EditEventCalendarFormData = z.infer<
  typeof EditEventCalendarFormSchema
>
